import { Component, OnDestroy, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from '../service/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  imports: [RouterModule],
})
export class BreadcrumbComponent implements OnDestroy {
  breadcrumbService = inject(BreadcrumbService);

  subscription: Subscription;

  items: MenuItem[] = [];

  constructor() {
    const breadcrumbService = this.breadcrumbService;

    this.subscription = breadcrumbService.itemsHandler.subscribe((response) => {
      this.items = response;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
